import OmniApiClient from "./base";

const RESOURCE = "/amazon";

export default {
  // Get all credentials
  getAll(params) {
    return OmniApiClient.get(`${RESOURCE}/`, { params });
  },

  // Get credential by ID
  get(id) {
    return OmniApiClient.get(`${RESOURCE}/${id}`);
  },

  // Create new credential
  create(data) {
    return OmniApiClient.post(`${RESOURCE}/`, data);
  },

  // Update credential
  update(id, data) {
    return OmniApiClient.put(`${RESOURCE}/${id}`, data);
  },

  // Delete credential
  delete(id) {
    return OmniApiClient.delete(`${RESOURCE}/${id}`);
  },

  // Test credentials (unsaved)
  test(data) {
    return OmniApiClient.post(`${RESOURCE}/test`, data);
  },

  // Test saved credential
  testSaved(id) {
    return OmniApiClient.post(`${RESOURCE}/${id}/test`);
  },

  // Check Hazmat status for ASINs
  checkHazmat(asins) {
    return OmniApiClient.post(`${RESOURCE}/hazmat_check`, { asins });
  },

  // Toggle active status
  toggleActive(id) {
    return OmniApiClient.post(`${RESOURCE}/${id}/toggle-active`);
  },
};
